import { IconButton } from '@capsicum/common-web';
import { HistoryIcon, PlusIcon, ReceiveArrowIcon, StakeIcon, WithdrawArrowIcon } from '@capsicum/common-web/icons';
import { useNCWalletActionBar } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

import { useNCWalletActionBarNavigation } from '../../hooks/useNCWalletActionBarNavigation';

/**
 * This component returns the Non Custodial Wallet ActionBar UI compoment
 * @param {EnhancedWalletCurrency} data data props
 * @param {boolean} isLoading whether the data is loading or not
 * @returns JSX Element
 */
export const NCWalletActionBar = () => {
	const { navigationCallbacks } = useNCWalletActionBarNavigation();
	const { ncWalletButtonProps } = useNCWalletActionBar({
		HistoryIcon,
		PlusIcon,
		ReceiveArrowIcon,
		StakeIcon,
		WithdrawArrowIcon
	});

	return (
		<S.Wrapper>
			{ncWalletButtonProps.map(button => {
				return (
					<S.IconContainer key={button.bottomText}>
						<IconButton
							bottomText={button.bottomText}
							disabled={button.state !== 'enabled'}
							icon={button.icon}
							isLoading={button.state === 'pending'}
							testID={button.testID}
							onClick={navigationCallbacks[button.to]}
						/>
					</S.IconContainer>
				);
			})}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
		align-items: center;
		padding: ${({ theme }) => `${theme.spacings.large} 0`};
		max-width: 550px;
		margin: 0 auto;
	`;

	export const IconContainer = styled.div`
		display: flex;
		flex-direction: row;
		flex: 1;
		justify-content: center;
		align-items: center;
	`;
}
